module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/bighorn_national_forest-b90c5e8ab4d80d4eae4bd8bf7076342c.jpg";